import { render, staticRenderFns } from "./LandPopupSelect.vue?vue&type=template&id=4fa8d8b8&scoped=true&"
import script from "./LandPopupSelect.vue?vue&type=script&lang=js&"
export * from "./LandPopupSelect.vue?vue&type=script&lang=js&"
import style0 from "./LandPopupSelect.vue?vue&type=style&index=0&id=4fa8d8b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8d8b8",
  null
  
)

export default component.exports